// TOOD: BUG - if page calls brand, this removes brandguide from path!
export default function changeSlug(pageAlias: string, slug: string) {
  const pathname = window.location.pathname;
  const pre = pathname.substr(0, pathname.indexOf(pageAlias));
  const newPath = `${pre}${pageAlias}${slug ? `/${slug}` : ''}`;

  if (newPath !== pathname) {
    window.history.replaceState(null, null, newPath);
  }
}
